<mat-dialog-content class="dialog-content">
  <div class="modal-header">
    <p class="title">Farbe wahlen</p>
    <app-modal-close-button
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <div class="modal-body">
    <div class="colors-container">
      <div
        class="color"
        *ngFor="let color of colors"
        [style.background-color]="color"
        (click)="selectColor(color)"
        [ngClass]="{ selected: color === selectedColor }">
        <mat-icon class="check-icon" *ngIf="color === selectedColor">
          check_circle
        </mat-icon>
      </div>
    </div>
    <div style="display: flex; gap: 16px; justify-content: flex-end">
      <button class="button" [disabled]="!selectedColor" (click)="saveColor()">
        Speichern
      </button>
    </div>
  </div>
</mat-dialog-content>
